import isEmpty from "../validation/is-empty";
import { SET_CURRENT_USER, REDIRECT, SET_TOKEN_EXPIRE_POPUP, SET_WORKING } from "../actions/types";

const initialState = {
	isAuthenticated: false,
	tokenExpiredPopup: false,
	working: false,
	user: {}
};

export default function(state = initialState, action) {
	switch (action.type) {
		case SET_CURRENT_USER:
			return {
				...state,
				isAuthenticated: !isEmpty(action.payload),
				user: action.payload
			};

		case REDIRECT:
			return {
				...state
			};
		case SET_TOKEN_EXPIRE_POPUP:
			return {
				...state,
				tokenExpiredPopup: action.payload
			};
		case SET_WORKING:
			return {
				...state,
				working: action.payload
			};

		default:
			return state;
	}
}
